import TagSVG from "./TagSVG";

function TagIcon({ name, count, sameTagsClickHandler, id }) {
  return (
    <div>
      <TagSVG id={id} text={name} count={count} sameTagsClickHandler={sameTagsClickHandler} />
    </div>
  );
}

export default TagIcon;
